var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#1877F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_745_37422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5524 7.44743C18.4508 7.34581 18.3016 7.30821 18.1639 7.34948L6.21391 10.9345C5.6873 11.0925 5.3335 11.568 5.3335 12.118C5.3335 12.6603 5.69769 13.1432 6.2192 13.2922L11.2658 14.734L12.7077 19.7806C12.8567 20.3021 13.3395 20.6663 13.8821 20.6663C14.4318 20.6663 14.9074 20.3125 15.0653 19.7859L18.6503 7.83586C18.6916 7.69823 18.654 7.54904 18.5524 7.44743ZM6.11475 12.1178C6.11475 11.9157 6.2448 11.7409 6.43839 11.6828L16.9044 8.543L11.4681 13.9794L6.43381 12.541C6.24597 12.4873 6.11475 12.3134 6.11475 12.1178ZM14.317 19.5614C14.259 19.755 14.0842 19.8851 13.8819 19.8851C13.6865 19.8851 13.5125 19.7539 13.4589 19.566L12.0205 14.5317L17.4569 9.0954L14.317 19.5614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_745_37422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(5.3335 7.33301)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBlue);
export default __webpack_public_path__ + "static/media/send-blue.6d4a1ba6cef9363469cdb63949ceb323.svg";
export { ForwardRef as ReactComponent };